import { render, staticRenderFns } from "./AsiSkeletonCard.vue?vue&type=template&id=009591d8&scoped=true"
import script from "./AsiSkeletonCard.vue?vue&type=script&lang=ts"
export * from "./AsiSkeletonCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009591d8",
  null
  
)

export default component.exports